<template>
  <div class="mall-header">
    <div class="mall-header__back" @click="$emit('back-click')">
      <img
        class="mall-header__back-icon"
        src="@/assets/home/icn_arrow_left.png"
        alt="뒤로가기"
      />
    </div>
    <span v-if="title" class="mall-header__title">{{ title }}</span>
    <!-- 우측 영역 (기본: 프로필 추가 버튼) -->
    <slot name="right">
      <MallRoundButton :label="'프로필 추가'" @click="$emit('add-profile-click')" />
    </slot>
  </div>
</template>

<script>
import MallRoundButton from '@/components/new/atoms/MallRoundButton.vue'

export default {
  name: 'MallHeader',
  components: {
    MallRoundButton,
  },
  props: {
    // 가운데 제목 (없으면 미노출)
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.mall-header {
  display: flex;
  width: 100%;
  height: 64px;
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.mall-header__back {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
}

.mall-header__back-icon {
  display: block;
  width: 24px;
  height: 24px;
}

.mall-header__title {
  flex: 1;
  min-width: 0;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallHeader.vue